import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { secondsToPixels } from 'utils/timeline'

interface IUseTimelineItemBodyRectProps {
  trimStart?: number
  originalDuration?: number
  playbackSpeed?: number
}

const useTimelineItemBodyRect = ({
  trimStart = 0,
  originalDuration = 0,
  playbackSpeed = 1
}: IUseTimelineItemBodyRectProps) => {
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const pixelsPerSecond = useMemo(
    () => secondsToPixels(1, timelineRulerSliceDuration),
    [timelineRulerSliceDuration]
  )

  return {
    bodyWidth: (originalDuration * pixelsPerSecond) / playbackSpeed,
    bodyLeft: -((trimStart / playbackSpeed) * pixelsPerSecond)
  }
}

export default useTimelineItemBodyRect
